// Page Heure de lever (MatineeController cote serveur).

// NORMALE : duree fixe ; SEANCE : duree de la seance + marge, moins les
// trajets courus ; COURUE : trajet en courant, compte dans la seance ;
// DOUCHE : sa fin est l'heure de reference.
export type TypeEtape = 'NORMALE' | 'SEANCE' | 'COURUE' | 'DOUCHE';

export type Etape = {
  libelle: string;
  dureeMin: number;
  type: TypeEtape;
};

export type Scenario = {
  nom: string;
  margeMin: number;
  etapes: Etape[];
  // Scenario favori (un seul) : son heure de lever est affichee sur l'accueil.
  favori?: boolean;
};

export type Matinee = {
  finDouche: string; // HH:MM
  scenarios: Scenario[];
  // Vrai tant que rien n'a ete enregistre (scenarios par defaut).
  parDefaut?: boolean;
};

function entetes(): HeadersInit {
  return {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
  };
}

async function verifier(response: Response): Promise<Matinee> {
  if (response.ok) return (await response.json()) as Matinee;
  let message = 'statut ' + response.status;
  try {
    const erreur = await response.json();
    if (erreur?.message) message = erreur.message;
  } catch {
    // corps vide ou non JSON
  }
  throw new Error(message);
}

export async function lireMatinee(): Promise<Matinee> {
  return verifier(await fetch('/api/matinee', { headers: entetes() }));
}

export async function enregistrerMatinee(m: Matinee): Promise<Matinee> {
  return memoriser(verifier(await fetch('/api/matinee', { method: 'PUT', headers: entetes(), body: JSON.stringify(m) })));
}

// Configuration partagee par les tuiles de l'accueil (aujourd'hui, demain) :
// une seule requete par chargement de page.
let enCache: Promise<Matinee> | null = null;
export function lireMatineeEnCache(): Promise<Matinee> {
  if (!enCache) {
    enCache = lireMatinee();
    enCache.catch(() => { enCache = null; });
  }
  return enCache;
}

/** Revient aux scenarios par defaut. */
export async function reinitialiserMatinee(): Promise<Matinee> {
  return memoriser(verifier(await fetch('/api/matinee', { method: 'DELETE', headers: entetes() })));
}

// Apres un enregistrement, l'accueil reprend la configuration a jour (sinon
// le favori choisi n'y apparait qu'au rechargement de la page).
async function memoriser(m: Promise<Matinee>): Promise<Matinee> {
  const config = await m;
  enCache = Promise.resolve(config);
  return config;
}
